import React from "react";

const JQuery_Dimensions = () => {
  return (
    <div>
      <h1>JQuery_Dimensions</h1>
      <p>Placeholder component for: "JQuery_Dimensions"</p>
    </div>
  );
};

export default JQuery_Dimensions;
